/*
 * @Author: your name
 * @Date: 2022-02-08 15:10:42
 * @LastEditTime: 2024-11-21 21:05:46
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyMultiTextEditor\index.jsx
 */
import React from 'react';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import { BsyWidget } from '../BsyWidget';
import { BsyConfig } from '../../global/BsyConfig';

export default class BsyMultiTextEditor extends BsyWidget {

    constructor(props) {
        super({
            baseCls: "bsy-multi-text",
            value: [],
            waterMark: React.language("widget.multiText.placeholder"),
            width: 375,
            minWidth4TagInput: 90,
            allowMultiTag: !0,
            autoWrap: !1,
            onStopEdit: null,
            ...props
        });
        this.state = {
            css: {},
            seaching: false,
            value: this.options.value,
            items: this.options.items
        }
        this.inputref = React.createRef();
        this.ref = React.createRef();
    }


    componentDidMount() {
        super.componentDidMount();

    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {


        if (!BsyUtils.compare(this.state.value, nextProps.value)) {
            if (Array.isArray(nextProps.value)) {
                this.setState({
                    value: [...nextProps.value],
                })
            }

        }
    }

    getValue = () => {
        return this.state.value
    }

    onFocus = (e) => {
        this.spanSelectClear();
    }
    onBlur = (e) => {
        const { value } = this.state
        let val = e.target.innerText.trim();
        if (!val) {
            return
        }
        let newValue = [...value, val]
        e.target.innerText = '';
        this.setState({
            value: newValue
        }, () => {
            this.value = newValue;
            this.inputref.current.focus()
            BsyUtils.applyFunc(this, this.options.onStopEdit, [this.value], !1);
        })
    }

    spanSelect = (e) => {
        let tags = this.ref.current.querySelectorAll('.val-tag')
        for (let index = 0; index < tags.length; index++) {
            const element = tags[index];
            element.classList.remove('active')
        }
        e.target.classList.add('active')
    }

    spanSelectClear = (e) => {
        let tags = this.ref.current.querySelectorAll('.val-tag')
        for (let index = 0; index < tags.length; index++) {
            const element = tags[index];
            element.classList.remove('active')
        }

    }

    _removeValTag = () => {
        let tags = this.ref.current.querySelectorAll('.val-tag')
        let tagindex = -1;
        for (let index = 0; index < tags.length; index++) {
            const element = tags[index];
            if (element.classList.contains('active')) {
                tagindex = index
            }
        }
        if (tagindex > -1) {
            const { value } = this.state
            let newValue = [...value];
            newValue.splice(tagindex, 1);
            this.setState({
                value: newValue,
            })
        } else {
            if (!this.inputref.current.innerText) {
                const { value } = this.state
                let newValue = [...value];
                newValue.splice(newValue.length - 1, 1);
                this.setState({
                    value: newValue,
                })
            }
        }
    }

    _focusValTag = (type) => {
        let tags = this.ref.current.querySelectorAll('.val-tag')
        let tagindex = -1;
        for (let index = 0; index < tags.length; index++) {
            const element = tags[index];
            if (element.classList.contains('active')) {
                tagindex = index
            }
            element.classList.remove('active')
        }
        if (tagindex > -1) {
            switch (type) {
                case "left": {
                    if (tagindex > 0) {
                        tags[tagindex - 1].classList.add('active');
                    } else {
                        tags[0].classList.add('active');
                    }

                    break;
                }
                case "right": {
                    if (tagindex < tags.length - 1) {
                        tags[tagindex + 1].classList.add('active');
                    } else {
                        tags[tags.length - 1].classList.add('active');
                    }
                    break;
                }
                default:
            }
        }
    }

    onKeyDown = (t) => {
        switch (t.which || t.keyCode) {
            case BsyConfig().CONST.KEY_CODE.ENTER:
                var sUserAgent = navigator.userAgent;
                var isIE = sUserAgent.indexOf("compatible") > -1 && sUserAgent.indexOf("MSIE") > -1;
                if (isIE) {
                    window.event.returnValue = false;
                } else {
                    t.preventDefault();
                }
                this.inputref.current.blur();
                break;
            case BsyConfig().CONST.KEY_CODE.DELETE:
            case BsyConfig().CONST.KEY_CODE.BACKSPACE:
                this._removeValTag();
                break;
            case BsyConfig().CONST.KEY_CODE.LEFT:
                this._focusValTag("left");
                break;
            case BsyConfig().CONST.KEY_CODE.RIGHT:
                this._focusValTag("right")
                break;
            default:
        }
    }

    render() {

        const { value } = this.state
        const { cssName, waterMark, minWidth4TagInput, autoWrap, css } = this.options;

        return (
            <div className={cssName + ' ' + (autoWrap ? 'auto-wrap' : '')}
                tabIndex="-1"
                style={css}
                onKeyDown={this.onKeyDown}
                ref={this.element}
            >
                <div className='val-wrapper'>
                    <div className='val-list' ref={this.ref}>
                        {
                            value.map((data) => {
                                return <span
                                    onClick={this.spanSelect}
                                    className='val-tag' title={data} >{data}
                                </span>
                            })
                        }
                        <div
                            ref={this.inputref}
                            className="text-input"
                            contentEditable={true}
                            data-watermark={waterMark}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onClick={(e) => {
                                e.preventDefault();
                                this.inputref.current.focus()
                            }}
                            style={{
                                minWidth: minWidth4TagInput
                            }}></div>
                    </div>
                </div>
            </div>
        );
    }
}
